import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FrameToComeComponent } from './frame-to-come.component';
import { FrameShipmentComponent } from './components/frame-shipment/frame-shipment.component';
import { CanLeaveService } from '@app/core/services/can-leave.service';

const routes: Routes = [
  { path: '', component: FrameToComeComponent, pathMatch: 'full', canDeactivate: [CanLeaveService] },
  { path: 'track-shipment', component: FrameShipmentComponent, pathMatch: 'full' },
  { path: 'track-shipment/:cartId', component: FrameToComeComponent, pathMatch: 'full', canDeactivate:[CanLeaveService]},
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FrameToComeRoutingModule { }
